import React from 'react';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
export const Switch = ({ cheked,onLabel,offLabel,onChange}) => (

    <BootstrapSwitchButton
        checked={cheked}
        onlabel={onLabel}
        offlabel={offLabel}
        onChange={onchange}
    />

 
)



// WEBPACK FOOTER //
// ./Public/src/js/component/ticket/Switch.jsx